import * as React from "react";
const MiniHaircutMale3 = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="468 50 200 280">
		<title>{"coiffure m 3"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect fill="none" width={1080} height={1920} />
		</g>
		<g id="coiffures_m" data-name="coiffures m">
			<path
				fill={color}
				stroke="black"
				strokeWidth="0.25"
				d="M494,208l-3-11-5-1s-4-22-4-29,0-37,4-47c-3-30,30-58,74-58,33,0,64,3,81,53,7,7,3,56,2,62s-8,20-8,20l-2,14s-4-16-3-19l2-6s-5-2-6-6-.61-21.69-.61-21.69S612,148,603,149c0,0,3,4,3,12s-78,7-101-23c3,27-10,39-10,39S497,200,494,208Z"
			/>
		</g>
	</svg>
);
export default MiniHaircutMale3;
